export default {
  label_item: "Item",
  label_model: "Model",
  label_location: "Location",
  label_unknown: "Unknown",
  designation_unknown: "Unknown Designation",
}
